import { render, staticRenderFns } from "./selOpcionesPartes.vue?vue&type=template&id=7c8e0924&scoped=true&"
import script from "./selOpcionesPartes.vue?vue&type=script&lang=js&"
export * from "./selOpcionesPartes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e0924",
  null
  
)

export default component.exports